import { useRef, useState } from 'react';

const CONSENT_KEY = 'clicklaw.companionConsent';

export const hasCompanionConsent = (): boolean =>
  localStorage.getItem(CONSENT_KEY) === 'accepted';

export function useCompanionConsent() {
  const [showModal, setShowModal] = useState(false);
  const pendingAction = useRef<(() => void) | null>(null);

  const requestConsent = (action: () => void) => {
    if (hasCompanionConsent()) {
      action();
      return;
    }
    pendingAction.current = action;
    setShowModal(true);
  };

  const onAccept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    setShowModal(false);
    pendingAction.current?.();
    pendingAction.current = null;
  };

  const onDecline = () => {
    setShowModal(false);
    pendingAction.current = null;
  };

  return { showModal, requestConsent, onAccept, onDecline };
}
